<template>
  <b-sidebar
    :id="sidebarId"
    :visible="visible"
    bg-variant="white"
    :sidebar-class="sidebarClass"
    shadow
    backdrop
    no-header
    right
    @hidden="$emit('close')"
    @change="val => $emit('update:visible', val)">
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ title }}</h5>
        <i class="fas fa-times ml-1 cursor-pointer" @click="hide"></i>
      </div>
      <b-form class="p-2" @submit.prevent="$emit('submit')">
        <slot />
        <div class="d-flex mt-2">
          <b-button variant="primary" type="submit" :disabled="loading" class="mr-1">
            <SpinnerLoading v-if="loading" />
            <span v-else>{{ submitLabel }}</span>
          </b-button>
          <b-button variant="outline-secondary" @click="hide">Cancel</b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar, BForm, BButton } from 'bootstrap-vue'
import SpinnerLoading from '@/components/SpinnerLoading'

export default {
  name: 'WlFormSidebar',
  components: { BSidebar, BForm, BButton, SpinnerLoading },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: 'Form' },
    sidebarId: { type: String, required: true },
    loading: { type: Boolean, default: false },
    submitLabel: { type: String, default: 'Save' },
    sidebarClass: { type: String, default: 'sidebar-lg' },
  },
}
</script>
